import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Twitch";
const Twitch = memo(themed(Icon));
export {
  Twitch
};
//# sourceMappingURL=twitch.js.map
